module.exports = __webpack_public_path__ + "img/GOPR1662.4c6b46be.png";